<template>
    <div class="home">
        <HomeNav :products=products :currentId=currentId :showInfos=showInfos @update-infos="updateInfos"
                 :display=display @update-display="updateDisplay"></HomeNav>

        <div id="product-container" class="container" :class="{'little': display == 'little', 'medium': display == 'medium', 'big': display == 'big', 'hidden': display == 'single'}">

            <div class="post-login" v-if="!isLoggedIn">
                <img src="@/assets/img/sweetysmart_logo_hori.png" alt="sweetysmart logo">
                <h2>One Single Destination <br>for the World Most <br>Stylish Tech Accessories</h2>
                <p>Join the community of demanding <br>esthets and techstylists influencers</p>
                <form onsubmit="return false;">
                    <input type="email" placeholder="email" name="email" v-model="user.email">
                    <input type="password" placeholder="password" name="password" v-model="user.password">
                    <p>or join us with</p>
                    <router-link :to="{name: 'subscribe'}">Join Us</router-link>
                    <button @click="logUser">Sign In</button>
                </form>
            </div>

            <figure v-for="(product, index) in products" :key="product._id" @click="displaySingle(index)"
                    :style="{backgroundImage: `url(${product.mainPicture})`}">
                <figcaption :class="{'hidden': !showInfos}">
                    <span v-for="tag in product.tags.slice(0, 2)" :key="tag._id" class="tag"><p>{{ tag.name }}</p></span>
                </figcaption>
            </figure>

            <div class="post" v-for="(post,i) in posts" :key="post._id" :style="{gridRowStart: (i*5)+1, gridRowEnd: (i*5)+3}">
                <img v-lazy="post.bg" alt="post background image">
                <div class="content">
                    <h3>{{post.title}}</h3>
                    <p>{{post.text}}</p>
                    <a target="_blank" :href=post.link>Read at {{post.link}}</a>
                    <div class="bottom">
                        <div class="matched"><p>Matched by {{post.by}}</p></div>
                        <div class="actions">
                            <button><img src="@/assets/img/heart_dark.png" alt="like button"><p>{{post.likes}}</p></button>
                            <button><img src="@/assets/img/share_dark.png" alt="share button"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button :class="{'hidden': display == 'single'}" class="green-btn" @click="getProducts()">Load more</button>



        <div class="product" :class="{'hidden': display != 'single'}">
            <div class="images">
                <img class="background" v-for="img in currentProduct.pictures" :key="img._id" src="">
            </div>
            <div class="content">
                <div class="p-nav">
                    <button class="ssm-previous" @click="displaySingle(currentId-1)"><img src="@/assets/img/arrow_previous.png" alt="previous article"></button>
                    <button class="ssm-next" @click="displaySingle(currentId+1)"><img src="@/assets/img/arrow_next.png" alt="next article"></button>
                </div>

                <div class="similar">
                    <div v-if="similar != ''" class="ssm-similar-sidebar">
                        <div>
                            <h3>#{{ similar | uppercase }}</h3>
                            <div>
                                <div class="ssm-similar-item"></div>
                                <div class="ssm-similar-item"></div>
                                <div class="ssm-similar-item"></div>
                            </div>
                        </div>
                    </div>
                    <ul>
                        <li @click="similar = ''"><font-awesome-icon v-if="similar != ''" :icon="times"></font-awesome-icon></li>
                        <li @click="similar = 'posts'"><div :class="{'selected': similar == 'posts'}"></div>POSTS</li>
                        <li @click="similar = 'looks'"><div :class="{'selected': similar == 'looks'}"></div>LOOKS</li>
                        <li @click="similar = 'match up'"><div :class="{'selected': similar == 'match up'}"></div>MATCH UP</li>
                        <li @click="similar = 'similar'"><div :class="{'selected': similar == 'similar'}"></div>SIMILAR</li>
                        <li @click="similar = 'same collection'"><div :class="{'selected': similar == 'same collection'}"></div>SAME COLLECTION</li>
                        <li @click="similar = 'same brand'"><div :class="{'selected': similar == 'same brand'}"></div>SAME BRAND</li>
                        <li @click="similar = 'open your list'"><div :class="{'selected': similar == 'open your list'}"></div>OPEN YOUR LIST</li>
                        <li @click="similar = 'same list'"><div :class="{'selected': similar == 'same list'}"></div>SAME LIST</li>
                    </ul>
                </div>

                <div class="action">
                    <div class="right-container">
                        <div>
                            <div class="chat-container" v-if="showChat">
                                <a href="#">Privacy</a>
                                <ul>
                                    <li><button>Everybody</button></li>
                                    <li><button>Chat With</button></li>
                                    <li><button>Ask Us</button></li>
                                </ul>
                                <div class="msg">
                                    <div v-for="message in messages" :key="message._id">
                                        <div class="msg-head"><h6>{{ message.user_from.firstname }} {{message.user_from.lastname}}</h6></div>
                                        <div class="msg-content">
                                            <div></div>
                                            <p>{{ message.content }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="close-chat green-btn" @click="showChat = false">
                                    <p>Chat</p>
                                    <button><i class="fa fa-times"></i></button>
                                </div>
                            </div>
                            <div class="likes" :class="{'hidden': hovering == false}" @mouseenter="showLikes()" @mouseleave="hideLikes()">
                                <p>#Like</p>
                                <ul>
                                    <li @click="likeProduct(-1)" class="reversed">
                                        <img v-if="userLike != -1" src="@/assets/img/top_menu/heart_top.png" alt="heart button">
                                        <img v-if="userLike == -1" src="@/assets/img/top_menu/heart_top_full.png" alt="heart button full">
                                    </li>
                                    <li @click="likeProduct(1)">
                                        <img v-if="userLike != 1" src="@/assets/img/top_menu/heart_top.png" alt="heart button">
                                        <img v-if="userLike == 1" src="@/assets/img/top_menu/heart_top_full.png" alt="heart button full">
                                    </li>
                                    <li @click="likeProduct(2)">
                                        <img v-if="userLike != 2" src="@/assets/img/top_menu/heart_top.png" alt="heart button">
                                        <img v-if="userLike == 2" src="@/assets/img/top_menu/heart_top_full.png" alt="heart button full">
                                    </li>
                                    <li @click="likeProduct(3)">
                                        <img v-if="userLike != 3" src="@/assets/img/top_menu/heart_top.png" alt="heart button">
                                        <img v-if="userLike == 3" src="@/assets/img/top_menu/heart_top_full.png" alt="heart button full">
                                    </li>
                                    <li @click="likeProduct(4)">
                                        <img v-if="userLike != 4" src="@/assets/img/top_menu/heart_top.png" alt="heart button">
                                        <img v-if="userLike == 4" src="@/assets/img/top_menu/heart_top_full.png" alt="heart button full">
                                    </li>
                                </ul>
                            </div>
                            <div v-if="isLoggedIn" class="interactions">
                                <div>
                                    <input type="text" placeholder="Add your feeling" v-model="message" @click="showChat = true" @keyup="sendMessage($event)">
                                    <div class="like-share">
                                        <button @click="likeProduct(1); displayChat()" @mouseenter="showLikes()" @mouseleave="hideLikes()" @keyup="sendMessage($event)">
                                            <img v-if="userLike < 1" src="@/assets/img/top_menu/heart_top.png" alt="heart button">
                                            <img v-if="userLike >= 1" src="@/assets/img/top_menu/heart_top_full.png" alt="heart button full">
                                        </button>
                                        <button><img src="@/assets/img/top_menu/share_top.png" alt="share button"></button>
                                        <button><img src="@/assets/img/top_menu/bookmark_top.png" alt="bookmark button"></button>
                                    </div>
                                </div>
                            </div>
                            <div class="style-and-buy">
                                <button v-if="!showChat" class="green-btn"><p>Buy at...</p></button>
                                <button v-if="!showChat" class="green-btn"><p>Style & Buy</p></button>
                            </div>
                        </div>
                    </div>
                    <div class="infos">
                        <span class="tag"><p>JBL X QUINCY JONES</p></span>
                        <span class="tag"><p>Headphones</p></span>
                        <span class="tag"><p>Wireless</p></span>
                        <span class="tag"><p>E 55BT Quincy Edition</p></span>
                        <span class="tag"><p>Double Devices Pairing</p></span>
                        <span class="tag"><p>Fold Flat</p></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import HomeNav from "@/components/HomeNav";
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: 'Home',
        components: {
            HomeNav
        },
        created() {
            this.getProducts()
            if (this.display !== "single") return;
            let that = this;
            document.body.addEventListener('keypress', (e) => {
                switch(e.key) {
                    case "ArrowLeft":
                        that.displaySingle(that.currentId - 1);
                        break;
                    case "ArrowRight":
                        that.displaySingle(that.currentId + 1);
                        break;
                    default:
                        break;
                }
            })
        },
        data() {
            return {
                posts: [{
                    type: 3,
                    title: "Louis Vuitton FW 17-18",
                    text: "",
                    bg: "http://163.172.150.46/assets/img/e21def9c86a2a466eb4508cc8db9e60f@2x.png",
                    by: "editor",
                    link: "tagwalk.com",
                    likes: 120
                },{
                    type: 1,
                    title: "Millennial pink, what the hell is it anyway? Well, it is #NationalPinkDay…",
                    text: "So, pink comes in a helluva lot of shades, as anyone who’s ever worked in fashion will tell you, from the merest hint of a blush (think red …",
                    bg: "@/assets/img/PP_post_07@2x.png",
                    by: "Laurenbaggins",
                    link: "glamour.com",
                    likes: 130
                }],
                display: 'medium',
                currentId: 0,
                currentProduct: {_id: null, tags: [], name: null, brand: null, mainPicture: null, pictures: []},
                showInfos: false,
                page: 1,

                user: {
                    email: "",
                    password: ""
                },

                message: "",
                room: {_id: null},
                messages: [],
                userLike: 0,

                hovering: false,
                hideTimer: null,
                showChat: false,
                img: process.env.VUE_APP_S3_URL,
                similar: ""
            }
        },
        computed: {
            products: {
                get(){
                    return this.$store.state.product.products
                },
                set(newValue){
                    this.$store.commit('product/STORE_PRODUCTS', newValue)
                }
            },
            ...mapGetters('security', ['isLoggedIn'])
        },
        methods: {
            ...mapActions('security', [
                'login'
            ]),
            ...mapActions('product', [
                    'getProduct',
                    'getAllProducts'
            ]),
            updateInfos(status){
                this.showInfos = status
            },
            updateDisplay(newDisplay){
              this.display = newDisplay
            },

            logUser() {
                this.badCredentialsMessage = false;
                this.loading = true;
                if (this.user.email === '' || this.user.password === '') return false;
                this.login({email: this.user.email, password: this.user.password})
                        .then(() => {
                            this.loading = false;
                            this.$router.push({name: "admin_products"})
                        })
                        .catch(() => {
                            this.loading = false;
                            this.badCredentialsMessage = true;
                        });
                return false;
            },

            getProducts(){
                this.getAllProducts(this.page).then(res => {
                    if (res.success) {
                        res.products.map(p => {
                            p.mainPicture = this.img + '/' + p.mainPicture
                        });
                        this.products = this.products.concat(res.products);
                        if (this.currentProduct._id == null && this.products.length > 0) this.currentProduct = this.products[0];
                        this.page++;
                    }
                })
            },
            showLikes() {
                clearTimeout(this.hideTimer);
                this.timer = setTimeout(() => {
                    this.hovering = true;
                }, 1000);
            },
            displaySingle(i) {
                this.room = {_id: null};
                this.messages = [];
                this.userLike = 0;

                if (i < 0) {
                    i = this.products.length - 1;
                } else if (i >= this.products.length) {
                    i = 0;
                }

                this.currentId = i;
                this.currentProduct = this.products[i];
                this.display = "single";

                this.getProduct(this.currentId).then(data => {
                    console.log(data)
                })
                /*
                this.messageService.getMessagesForProduct(this.products[i]._id)
                        .subscribe(
                                res => {
                                    if (res.success) {
                                        this.room = res.room;
                                        this.messages = res.messages;
                                    }
                                },
                                err =>  console.log(err)
                        );

                this.service.getUserLikeProduct(this.products[i]._id)
                        .subscribe(
                                res => {
                                    if (res.success) {
                                        if (res.rate != null) this.userLike = res.rate.value;
                                    }
                                },
                                err =>  console.log(err)
                        );

                if (this.isLoggedIn()) {
                    this.service.visitProduct(this.products[i]._id)
                            .subscribe(
                                    res => {
                                        if (res.success) {
                                        }
                                    },
                                    err =>  console.log(err)
                            );
                }*/
            }
        }
    }
</script>

<style scoped lang="scss">
    @font-face {
        src: local("Refrigerator"),
        url(../assets/fonts/Refrigerator_Deluxe.ttf);
    }

    .green-btn {
        font-size: 15px;
        display: block;
        width: auto;
        height: auto;
        margin: 0 auto 10px;
        border: 0;
        padding: 5px 25px;
        cursor: pointer;
        text-align: center;
    }

    .hidden {
        display: none !important;
    }

    .container {
        display: grid;
        grid-template-columns: repeat(8,1fr);
        grid-column-gap: 20px;
        justify-content: center;
        position: relative;
        width: calc(100% - 20px);
        margin: 80px 0 0 20px;
        align-items: center;

        .post-login {
            grid-row: 1/3;
            grid-column: 1/3;
            height: 100%;
            background-color: #1a3233;
            text-align: center;

            img {
                width: 80%;
                margin-top: 75px;
            }

            h2, p{
                font-family: Refrigerator-light;
                margin-top: 50px;
                letter-spacing: 1px;
            }

            h2{
                font-size: 21px;
                color: #7c918d;
            }

            p {
                font-size: 14px;
                color: #5b7671;
            }

            form {
                margin-top: 20px;

                input {
                    font-size: 14px;
                    display: block;
                    width: 80%;
                    margin: 10px auto auto;
                    border-width: 0 0 1px;
                    border-color: #3c5150;
                    padding: 5px;
                    color: #5b7671;
                    background-color: transparent;
                }

                button, a {
                    font-family: Refrigerator;
                    font-size: 20px;
                    border: 1px solid #5b7671;
                    padding: 5px 10px;
                    color: #7c918d;
                    background-color: transparent;
                    cursor: pointer;
                    text-decoration: none;
                }
            }
        }

        .post {
            position: relative;
            grid-column-start: 3;
            grid-column-end: 5;
            overflow: hidden;

            > img {
                width: 100%;
            }

            .content {
                position: absolute;
                left: 15px;
                bottom: 0;
                width: calc(100% - 30px);
                background-color: hsla(0,0%,100%,.8);
                overflow: hidden;

                h3, p {
                    font-family: Roboto;
                    font-style: italic;
                    font-weight: 300;
                    padding: 0 10px;
                    color: var(--light-green);
                }

                p {
                    font-size: 13px;
                    margin: 2px;
                }

                a {
                    font-family: Roboto;
                    font-size: 10px;
                    font-style: italic;
                    font-weight: 300;
                    display: block;
                    color: var(--light-green);
                    padding: 0 10px;
                    text-decoration: none;
                    text-align: right;
                }

                .bottom{
                    display: flex;
                    justify-content: space-between;
                    margin-top: 10px;

                    .matched {
                        width: 60%;
                        height: 18px;
                        margin-left: -2px;
                        background-color: var(--main-green);
                        transform: skewX(-5deg);

                        p {
                            font-family: Roboto;
                            font-size: 11px;
                            font-style: italic;
                            margin: 0;
                            color: var(--light-green);
                            text-align: center;
                            line-height: 18px;
                            transform: skewX(5deg);
                        }
                    }

                    .actions {
                        display: flex;
                        align-items: flex-start;
                        padding-right: 15px;

                        button {
                            background-color: transparent;
                            border: none;
                            padding: 0;

                            img {
                                height: 12px;
                            }

                            p {
                                font-family: Refrigerator-light;
                                font-size: 12px;
                                font-style: normal;
                                color: #3c5150;
                                text-align: center;
                            }
                        }
                    }
                }
            }
        }

        figure {
            position: relative;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            width: 148px;
            height: 250px;
            margin: 0 2px 15px;
            padding: 10px;
            border: 1px solid #d4e3df;
            background: #fefefe none 50%;
            background-size: cover;
            overflow: hidden;
            cursor: pointer;
            box-sizing: border-box;
            transition-duration: .1s;

            &:nth-child(2n) {
                margin-top: 30px;
            }

            &:hover figcaption{
                display: block !important;
            }

            figcaption{
                font-size: .9rem;
                line-height: 1.5;
                width: 100%;
                color: #444;

                .tag {
                    font-size: 13px;
                    font-family: Refrigerator;
                    font-weight: 700;
                    display: inline-block;
                    margin: 2px;
                    color: #b1c4bf;
                    background-color: var(--main-green);
                    padding: 2px 10px;
                    transform: skewX(-5deg);
                    cursor: pointer;

                    p{
                        display: inline-block;
                        margin: 0;
                    }
                }
            }
        }
    }

    .product{

        .images {
            position: absolute;
            width: 100%;
        }

        .content{
            position: fixed;
            top: 53px;
            right: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: calc(100% - 30px);
            height: 85vh;


            .p-nav {
                display: flex;
                width: 80%;
                margin: 20px auto 0;

                button {
                    font-size: 40px;
                    width: 50px;
                    height: 50px;
                    margin: auto;
                    border: none;
                    color: #556b69;
                    background-color: transparent;
                    cursor: pointer;

                    img {
                        height: 46px;
                    }
                }
            }

            .similar {
                color: #556b69;
                width: 200px;

                ul {
                    list-style: none;
                    margin: 0;

                    li {
                        margin: 8px 0;
                        font-family: Refrigerator;
                        font-size: 14px;
                        color: #7c918d;
                        position: relative;
                        cursor: pointer;
                        padding-left: 18px;
                        min-height: 16px;

                        div {
                            position: absolute;
                            top: 3px;
                            left: 0;
                            display: inline-block;
                            width: 8px;
                            height: 8px;
                            margin-right: 10px;
                            border: 1px solid #3c5150;
                            z-index: 2;
                        }
                    }
                }
            }

            .action {

                .right-container {
                    position: absolute;
                    top: 0;
                    right: -85px;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    width: 300px;
                    height: calc(100vh - 53px);
                    padding-right: 50px;
                    transform: skewX(-5deg);
                    overflow: hidden;
                    z-index: 100;

                    .likes {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 10px;
                        border: 1px solid #b1c4bf;
                        padding: 5px 25px 0 5px;
                        background-color: #fff;
                    }

                    .style-and-buy {
                        display: flex;
                        height: 41px;
                        margin-bottom: 30px;

                        button {
                            flex: 1;

                            &:first-child {
                                margin-right: 10px;
                            }

                            p {
                                font-size: 12px;
                                text-transform: uppercase;
                                margin: 3px;
                                color: #b1c4bf;
                                transform: skewX(5deg);
                            }
                        }
                    }
                }

                .infos {
                    .tag {
                        font-size: 13px;
                        font-family: Refrigerator;
                        font-weight: 700;
                        display: inline-block;
                        margin: 2px;
                        padding: 2px 10px;
                        color: #b1c4bf;
                        background-color: var(--main-green);
                        transform: skewX(-5deg);
                        cursor: pointer;

                        > * {
                            transform: skewX(5deg);
                        }

                        p {
                            display: inline-block;
                            margin: 0;
                        }
                    }
                }
            }
        }
    }
</style>
